import { Outlet, RouteObject } from 'react-router';

import { AppContainerWithMenu } from '@sternum/web/features/appContainerWithMenu';
import { ProtectedRoute } from '@sternum/web/routes/ProtectedRoute';
import { lazyImport } from '@sternum/web/utils/lazyImport';

import { widgetPaths } from './paths';

const { FullWidget } = lazyImport(
  () => import('@sternum/web/features/widget/views/fullWidget/FullWidget.view'),
  'FullWidget',
);
const { CreateUpdateWidget } = lazyImport(
  () => import('@sternum/web/features/widget/views/createUpdateWidget/CreateUpdateWidget.view'),
  'CreateUpdateWidget',
);

function Layout() {
  return (
    <ProtectedRoute>
      <AppContainerWithMenu>
        <Outlet />
      </AppContainerWithMenu>
    </ProtectedRoute>
  );
}

export const widgetRoutes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: widgetPaths.fullWidget.absolute,
        element: <FullWidget />,
      },
      {
        path: widgetPaths.updateWidget.absolute,
        element: <CreateUpdateWidget />,
      },
      {
        path: widgetPaths.createWidget.absolute,
        element: <CreateUpdateWidget />,
      },
    ],
  },
];
